import {
  IOrganizationRelationListingModel,
  OrganizationRelationListingModel,
} from './OrganizationRelationListingModel';

export interface IHospitalOrganizationRelationListingModel
  extends IOrganizationRelationListingModel {
  hospitalCount: number;
}

export class HospitalOrganizationRelationListingModel
  extends OrganizationRelationListingModel
  implements IHospitalOrganizationRelationListingModel
{
  hospitalCount: number;
  constructor(params: Partial<IHospitalOrganizationRelationListingModel>) {
    super(params);
    const { hospitalCount = 0 } = params;
    this.hospitalCount = hospitalCount;
  }
}
